<template>
  <Select
    placeholder="请选择保护等级"
    clearable
    :value.sync="value"
    @on-change="change"
  >
    <Option
      v-for="item in dicts.TreeProtectionLevel"
      :key="item.value"
      :value="item.value"
    >
      {{ item.label }}
    </Option>
  </Select>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";

@Component({
  props: {
    value: {
      type: [Array, String, Number],
      default: ""
    }
  }
})
export default class TreeProtectionLevelSelect extends Vue {
  change(value) {
    this.$emit("change", value);
  }
}
</script>
